import { render, staticRenderFns } from "./FormRekonKurirNew.vue?vue&type=template&id=5d408ea0&scoped=true"
import script from "./FormRekonKurirNew.vue?vue&type=script&lang=js"
export * from "./FormRekonKurirNew.vue?vue&type=script&lang=js"
import style0 from "./FormRekonKurirNew.vue?vue&type=style&index=0&id=5d408ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d408ea0",
  null
  
)

export default component.exports